<div class="modal-header p-4 bg-white">
    <h4 class="modal-title">{{ title }}</h4>
    <div *ngIf="contractId && contractFlowStatus == 10">
        <button class="btn btn-sm btn-success rounded-pill mx-2" (click)="approveContract()">
            {{ 'ApproveContract' | translate }}
        </button>

        <button class="btn btn-sm btn-outline-danger rounded-pill mx-2" (click)="rejectContract()">
            {{ 'RejectContract' | translate }}
        </button>
    </div>
    <div>
        <a class="text-dark" (click)="toggleInfoView()"
            *ngIf="(canOpenFile(attachments[currentIndex]?.file_type) || isMediaFile(attachments[currentIndex]?.file_type)) && canViewFileInfo && attachments.length > 0"
            ngbTooltip="{{ viewingFileMode ? ('ViewDetails' | translate) : ('ViewFile' | translate) }}">
            <i class="fe black-menu fs-2 mx-2" [ngClass]="viewingFileMode ? 'fe-info' : 'fe-eye'"></i>
        </a>
        <i class="fe fe-download black-menu fs-2 mx-2"
            *ngIf="attachments.length > 0 && !publicService.isUserInteractionDisabled()"
            (click)="download(attachments[currentIndex])" ngbTooltip="{{ 'Download' | translate }}"></i>
        <i class="fe fe-x black-menu fs-2 mx-2" (click)="activeModal.dismiss()"
            ngbTooltip="{{ 'CloseModal' | translate }}"></i>
    </div>
</div>
<div class="modal-body"
    [ngClass]="{'d-flex justify-content-center align-items-center': (attachments.length === 0 || viewingFileMode), 'p-0':viewingFileMode}"
    style="height: calc(100dvh - 80px);" (click)="activeModal.dismiss()">

    <!-- Carousel indicators - shown in both modes -->
    <div class="carousel-indicators" *ngIf="attachments.length > 1 && attachments.length <= 30"
        style="position: fixed; bottom: 20px; left: 50%; transform: translateX(-50%); z-index: 1001;">
        <button type="button" *ngFor="let attachment of attachments; let i = index"
            (click)="$event.stopPropagation(); navigateToIndex(i)" [ngClass]="{'active': i === currentIndex}"
            [attr.aria-label]="'Slide ' + (i + 1)"></button>
    </div>

    <ng-container *ngIf="attachments.length > 0">
        <ng-container *ngIf="!viewingFileMode">
            <div id="carouselExampleCaptions" class="carousel" (slid.bs.carousel)="onSlideChange($event)">
                <div class="carousel-inner">
                    <div class="carousel-item" *ngFor="let attachment of attachments; let i = index"
                        [ngClass]="{'active': i === currentIndex}">
                        <ng-container *ngIf="!canViewFileInfo; else elseTemplate">
                            <ng-container [ngSwitch]="getFileType(attachment.file_type)">
                                <ng-container *ngSwitchCase="'image'">
                                    <img [src]="attachment.stored_file_name" class="d-block"
                                        alt="{{ attachment.original_file_name }}" (click)="$event.stopPropagation()">
                                </ng-container>
                                <ng-container *ngSwitchCase="'audio'">
                                    <audio controls (click)="$event.stopPropagation()">
                                        <source [src]="attachment.stored_file_name" type="audio/wav">
                                        {{ 'AudioNotSupported' | translate }}
                                    </audio>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                        <ng-template #elseTemplate>
                            <div class="file-info-box" (click)="$event.stopPropagation()">
                                <div class="file-icon-container">
                                    <i class="fe fs-1" [ngClass]="{
                                        'fe-image': getFileType(attachment.file_type) === 'image',
                                        'fe-volume-2': getFileType(attachment.file_type) === 'audio',
                                        'fe-video': attachment.file_type.startsWith('video/'),
                                        'fe-file-text': !isMediaFile(attachment.file_type)}">
                                    </i>
                                </div>
                                <h5 class="file-name">{{ attachment.original_file_name }}</h5>

                                <div class="file-meta-info">
                                    <div class="meta-item">
                                        <span class="meta-label">{{ 'FileType' | translate }}:</span>
                                        <span class="meta-value">{{ getFileExtension(attachment) }}</span>
                                    </div>
                                    <div class="meta-item">
                                        <span class="meta-label">{{ 'FileSize' | translate }}:</span>
                                        <span class="meta-value">{{ getFormattedFileSize() }}</span>
                                    </div>
                                    <div class="meta-item">
                                        <span class="meta-label">{{ 'UploadedBy' | translate }}:</span>
                                        <span class="meta-value">{{ getUploadedByName() }}</span>
                                    </div>
                                    <div class="meta-item">
                                        <span class="meta-label">{{ 'UploadDate' | translate }}:</span>
                                        <span class="meta-value">{{ getUploadedDate() }}</span>
                                    </div>
                                </div>

                                <div class="d-flex gap-4">
                                    <p class="file-btn" (click)="$event.stopPropagation(); download(attachment)"
                                        *ngIf="!publicService.isUserInteractionDisabled()">
                                        {{ 'Download' | translate }}</p>
                                    <p class="file-btn" (click)="$event.stopPropagation(); toggleInfoView()"
                                        *ngIf="canOpenFile(attachments[currentIndex]?.file_type) || isMediaFile(attachments[currentIndex]?.file_type)">
                                        {{ getViewButtonText(attachments[currentIndex].file_type) | translate }}</p>
                                </div>
                            </div>
                        </ng-template>
                    </div>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="viewingFileMode">
            <ng-container *ngIf="isImage(fileType)">
                <img [src]="sanitizedUrl" class="d-block mx-auto" (click)="$event.stopPropagation()"
                    style="max-width: 100%; max-height: 80vh; border-radius: 10px;" alt="Image preview">
            </ng-container>

            <ng-container *ngIf="fileType.startsWith('audio/') && !isImage(fileType)">
                <audio controls style="width: 100%;" (click)="$event.stopPropagation()">
                    <source [src]="sanitizedUrl" [type]="fileType">
                    {{ 'AudioNotSupported' | translate }}
                </audio>
            </ng-container>

            <ng-container *ngIf="fileType.startsWith('video/') && !isImage(fileType)">
                <video controls style="max-width: 100%; max-height: 80vh; border-radius: 10px;" class="mx-auto d-block"
                    (click)="$event.stopPropagation()">
                    <source [src]="sanitizedUrl" [type]="fileType">
                    {{ 'VideoNotSupported' | translate }}
                </video>
            </ng-container>

            <ng-container
                *ngIf="!fileType.startsWith('audio/') && !fileType.startsWith('video/') && !isImage(fileType)">
                <iframe [src]="sanitizedUrl" class="custom-iframe" width="100%" height="100%"
                    (click)="$event.stopPropagation()"></iframe>
            </ng-container>
        </ng-container>
    </ng-container>

    <!-- Navigation buttons - shown in both modes -->
    <button class="carousel-control-prev" type="button" (click)="$event.stopPropagation(); navigatePrev()"
        *ngIf="attachments.length > 1">
        <span class="carousel-control-prev-icon" (click)="$event.stopPropagation()"></span>
    </button>
    <button class="carousel-control-next" type="button" (click)="$event.stopPropagation(); navigateNext()"
        *ngIf="attachments.length > 1">
        <span class="carousel-control-next-icon" (click)="$event.stopPropagation()"></span>
    </button>

    <ng-container *ngIf="attachments.length === 0">
        <img [src]="path">
    </ng-container>
</div>